import { isDesktop } from "utils/isDesktop";
import { gsap } from "animations/gsap";
import styles from "./Lottie.module.scss";
import { LottieComponentInt } from "interfaces";

const Lottie = ({
  index = 0,
  target,
  lottie,
  titles,
  headlines = [],
  selector,
  steps,
  upperOffset,
}: LottieComponentInt) => {
  const scrollTo = (i: number) => () => {
    const yExtra = selector ? 89 : 5; //Added "5" to avoid weird bug. 85 : 1;
    const duration =
      Math.abs(window.scrollY - (steps[i] + upperOffset + yExtra)) / 12000;

    gsap.to(window, {
      duration: duration,
      scrollTo: {
        y: Math.ceil(steps[i] + upperOffset + yExtra),
        autoKill: false,
      },
      ease: "none",
    });
  };

  return (
    <div
      className={`anim-lottie ${styles["lottie-wrapper"]}
      ${selector ? styles.selector : ""} ${!selector ? styles.visible : ""}`}
      style={{ zIndex: `${5 - index}` }}
    >
      {isDesktop && (
        <div className={styles["marker-wrapper"]}>
          {Array(headlines.length + titles.length)
            .fill(true)
            .map((_, i) => (
              <button
                key={i}
                className={`anim-marker ${styles.marker}`}
                onClick={scrollTo(i)}
                aria-hidden="true"
                tabIndex={-1}
              />
            ))}
        </div>
      )}
      {headlines.map((headline, i) => (
        <h2
          key={i}
          className={`anim-lottie-headline anim-no-step ${styles.headline}`}
        >
          {headline}
        </h2>
      ))}
      <div
        className={`${styles["content-wrapper"]}
        ${selector ? styles.selector : ""}`}
      >
        <div className={`${styles.eyebrow}`}>
          <div className={`anim-lottie-steps ${styles.steps}`}>
            <h6 className={`${styles.step} bold`}>
              STEP
              {Array(titles.length - 1)
                .fill(true)
                .map((_, i) => (
                  <span key={i} className={`anim-lottie-step`}>
                    {i + 1}
                  </span>
                ))}
            </h6>
            <h6 className={`${styles["of-length"]}  bold`}>
              OF {titles.length}
            </h6>
          </div>
          <h6 className={`anim-lottie-step ${styles.result} bold`}>RESULT</h6>
        </div>
        {titles.map((title, i) => (
          <h2 key={i} className={`anim-lottie-headline ${styles.title}`}>
            {title}
          </h2>
        ))}
      </div>

      <div
        id={target}
        className={`lottie-target ${styles["lottie"]}`}
        data-lottie={lottie}
      ></div>
    </div>
  );
};

export default Lottie;
